import React from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'
import { toCamelCaseObjectFromSnakeCase } from '../utils/toCamelCaseObjectFromSnakeCase'
import { App } from './App'

import { ErrorBoundaryComp } from './common/ErrorBoundary'

moment.locale('ja')

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('customer-public')
  if (el !== null) {
    const config = toCamelCaseObjectFromSnakeCase(JSON.parse(el.dataset.config || '{}'))
    ReactDOM.render(
      <ErrorBoundaryComp>
        <App config={config} />
      </ErrorBoundaryComp>,
      el,
    )
  }
})
